import '../../scss/pages/home.scss';

import { textareaHeight } from '../../js/textarea.js';
import { navbarHead } from '../../js/navbar-head.js';
import { dropDownMenu } from '../../js/drop-down-menu.js';
import { getSchedule } from '../../js/get-schedule.js';
import { faq } from '../../js/faq.js';
import { initWidgetsSlider, nextTripWidget } from '../../js/widgets/index.js';
import Topbar from '../../js/topbar.js';
import ButtonScrollTop from '../../js/button-scroll-top.js';
import LiveNotify from '../../js/live-notify.js';
import { copyLinkPageButton, sharePage } from '../../js/sharepage.js';
import { pageTitles } from '../../js/page-titles.js';

function ready() {
  new Topbar(document.querySelector('.dke_topbar'));

  textareaHeight();

  // скрытие часть текста пунктов меню темной шапки
  navbarHead();

  // выпадающее меню (desktop), бургер-меню (mobile)
  dropDownMenu();

  // добавление доступного времени к турам
  getSchedule();

  // блок faq
  faq();

  // кнопка прокрутки страницы вверх
  new ButtonScrollTop('.dke_button-scroll-top');

  //Инициализация попапа уведомления
  new LiveNotify('#dke_live-notify');

  // Инициализация слайдера виджетов
  initWidgetsSlider();

  // Следующая прогулка у виджетов
  nextTripWidget();

  //кнопка копирования в буфер ссылки страницы
  copyLinkPageButton('.dke_copylink__button');
  sharePage('.dke_sharepage');

  //Содержание
  pageTitles('.dke_pagetitles');
}

document.addEventListener('DOMContentLoaded', ready);
